import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { Carousel } from "react-bootstrap";

const ImageDialog = ({ open, onClose, images, title, description, type }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={fullScreen}>
      <DialogTitle sx={{ pr: 6 }}>
        {title}
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 10, top: 10 }}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {description && (
          <Typography
            variant="body2"
            component="div"
            className="dialog-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        {images.length > 0 ? (
          <Carousel indicators={images.length > 1} controls={images.length > 1}>
            {images.map((img, i) => (
              <Carousel.Item key={img.id || i}>
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/api/admin/${type}/images/${img.id}`}
                  alt={`${title || type} ${i + 1}`}
                  className="dialog-carousel-img"
                />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div className="home-empty-state">No images available for this item.</div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImageDialog;
